<template lang="pug">
section.section.mapbox(
    :class="{ active: edit, deleted: section.deleted, disabled: !status, clickable: !disabled }"
    @click="$emit('edit', section)"
)
    include /components/Page/Sections/base.pug
    .content-wrappers
        slot
        Map(
            :section="section"
            :config="markerConfig"
            :options="options"
            :section-setting-values="sectionSettingValues"
            :edit="false"
        )
    el-drawer.full-height-drawer.visible-overflow(
        v-if="editable"
        :title="$t('Edit {section}', { section: section.name })"
        :visible.sync="scopedUI.form"
        :before-close="confirmDiscard(() => changedSince(drawer.sectionSnapshot, drawer.section))"
        :wrapper-closable="false"
        :append-to-body="true"
        size="920px"
        :modal="true"
        @closed="resetDrawer"
        style="--drawer-body-offset: 492px"
    )
        .drawer-body(v-loading="drawer.loading" :class="{ 'no-tabs': !markerConfig }")
            Map(
                :section="drawer.section"
                :config="markerConfig"
                :options="options"
                :section-setting-values="drawerSettingValues"
                :edit="true"
            )

            //- show settings
            //- pins are not allowed
            .block-settings(v-if="!markerConfig && !contentConfig.length")
                .settings-wrap
                    include /components/Page/Sections/settings.pug

            el-tabs.tabs-pt-6(
                v-else-if="!drawer.loading"
                v-model="drawer.tab"
                tab-position="left"
            )
                el-tab-pane(v-if="contentConfig.length" name="content" :label="$t('Content')")
                    .tab-content(v-if="contents && contents.length")
                        .content-wrapper(
                            v-for="config in contentConfig"
                            v-if="checkConditions(config)"
                            :key="config.key"
                        )
                            template(v-if="config.type === 'html'")
                                .html-content(v-html="config.html")
                            media-content(
                                v-if="config.media && config.media.min === 1 && config.media.max === 1"
                                :section="drawer.section"
                                :config="config"
                                :section-settings="settings"
                                :section-setting-values="drawerSettingValues"
                                :edit="true"
                            )
                            image-content(
                                v-else-if="config.image && config.image.min === 1 && config.image.max === 1"
                                :section="drawer.section"
                                :config="config"
                                :options="options"
                                :section-settings="settings"
                                :section-setting-values="drawerSettingValues"
                                :inline="config.max === 1 && contentConfig.length === 1"
                                :edit="true"
                            )
                            input-contents(
                                v-else
                                :section="drawer.section"
                                :config="config"
                                :options="options"
                                :section-settings="settings"
                                :section-setting-values="drawerSettingValues"
                                :edit="true"
                            )
                el-tab-pane(name="pins" :label="$t('Pins')")
                    .tab-content(v-if="contents && contents.length")
                        Markers(
                            :section="drawer.section"
                            :config="markerConfig"
                            :options="options"
                            :section-setting-values="drawerSettingValues"
                            :edit="true"
                        )
                el-tab-pane(name="settings" :label="$t('Settings')")
                    .block-settings
                        .settings-wrap
                            include /components/Page/Sections/settings.pug
                    //- .block-settings
                        .settings-wrap
                            .publish-settings
                                .mt-8
                                include /components/Page/Sections/publish-settings.pug

                            .margin-settings(v-if="marginsFeatureEnabled")
                                hr.mb-8.mt-8
                                include /components/Page/Sections/margin-settings.pug

        .drawer-footer
            include /components/Page/Sections/section-drawer-footer.pug

</template>

<script>
import { useSetupStore } from '@/stores';

import Section from '@/components/Page/Sections/Section'
import Map from './Map'
import Markers from './Markers'

export default {
    name: 'MapBox',
    extends: Section,
    data() {
        return {
            drawer: {
                loading: false,
                saving: false,
                tab: 'pins',
                tabs: ['pins', 'content', 'settings'],
                section: undefined,
            }
        }
    },
    components: {
        Map,
        Markers
    },
    computed: {
        // This component renders publish-settings.pug, which gates the member
        // restriction block on the extensions the store can act on.
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        effectiveExtensions() {
            return useSetupStore().effectiveExtensions;
        },
        editable() {
            return true;
        },
        markerConfig() {
            const contents = this.contents || []
            return contents.find(el => el.key === 'marker')
        },
        contentConfig() {
            const contents = this.contents || []
            return contents.filter(el => el.key !== 'marker')
        }
    },
    methods: {
        resetDrawer() {
            this.$emit('cancel')

            // check if drawer section has been saved
            // if not, remove from state

            if (!this.drawer.changed && _.startsWith(this.drawer.section.id, 'new:')) {
                this.$nextTick(this.deleteSection)
            }

            this.drawer.loading = false
            this.drawer.saving = false
            this.drawer.tab = 'pins'
            this.drawer.section = undefined
        },
    }
}
</script>

<i18n>
{
    "en": {
        "Edit {section}": "Edit {section}"
    },
    "de": {
        "Edit {section}": "{section} bearbeiten"
    }
}
</i18n>
